import React, {useReducer} from 'react'

import LoginActions from '../../../../actions/LoginActions.js'
import reducer from '../../../../helpers/reducer.js'

import {H3, H5, Alert, Button} from '../../../../components/UI/index.js'
import {FormStack, Toggle, Input, Select} from '../../../../components/UI/forms/index.js'
import {Customer} from '../../../../../server/functions/customers/customers.types.js'

interface ShoptraderSettingsProps {
    user: Customer
    onChange: (user: Customer, save?: boolean) => void
}

interface ShoptraderSettingsState {
    loading: boolean
    verified: boolean
    error: string
}

const initialState = {
    loading: false,
    verified: false,
    error: ''
}

export default function ShoptraderSettings({user, onChange}: ShoptraderSettingsProps) {
    const [{loading, verified, error}, dispatch] = useReducer<React.Reducer<ShoptraderSettingsState, Partial<ShoptraderSettingsState>>>(reducer, initialState)

    function onChangeChecked(key, event) {
        user.settings.webshops.shoptrader[key] = event.target.checked

        onChange(user)
    }

    function onChangeValue(key, event) {
        user.settings.webshops.shoptrader[key] = event.target.value

        onChange(user)
    }

    function onVerifyConnection() {
        dispatch({loading: true, verified: false, error: ''})

        onChange(user, true)

        setTimeout(() => { // wait for saving
            LoginActions.verifyWebshop('shoptrader', (err) => {
                if (err) {
                    dispatch({loading: false, error: `Verificatie niet succesvol, controleer de ingevulde gegevens. Foutmelding: ${err}`})
                } else {
                    dispatch({loading: false, verified: true})
                }
            })
        }, 1000)
    }

    return (
        <div>
            <H3 style={{marginBottom: 36}}>Shoptrader</H3>

            <H5 style={{marginBottom: 24}}>Instellingen</H5>

            <FormStack>
                <Toggle
                    label='Actief'
                    checked={user.settings.webshops.shoptrader.active}
                    onChange={(event) => onChangeChecked('active', event)}
                />

                {user.settings.webshops.shoptrader.active &&
                    <>
                        <Input
                            label='Webshop url'
                            value={user.settings.webshops.shoptrader.url}
                            onChange={(event) => onChangeValue('url', event)}
                        />

                        <Input
                            label='Api Token'
                            value={user.settings.webshops.shoptrader.apiKey}
                            onChange={(event) => onChangeValue('apiKey', event)}
                        />

                        <Select
                            label='Update bestelling status in Shoptrader'
                            info=''
                            value={user.settings.webshops.shoptrader.updateStatus}
                            onChange={(event) => onChangeValue('updateStatus', event)}
                        >
                            <option value=''>Nooit</option>
                            <option value='confirm'>Na bevestigen</option>
                            <option value='afterSent'>Na verzenden</option>
                        </Select>

                        <Toggle
                            label='Consument opmerking meegeven als bezorginstructie'
                            checked={user.settings.webshops.shoptrader.useComment}
                            onChange={(event) => onChangeChecked('useComment', event)}
                        />

                        <Button
                            variant='text'
                            loading={loading}
                            onClick={onVerifyConnection}
                        >
                            Verifieer
                        </Button>

                        {error && (
                            <Alert style={{marginBottom: 6}} onClose={() => dispatch({error: ''})} variant='error'>{error}</Alert>
                        )}

                        {!error && verified && (
                            <Alert style={{marginBottom: 6}} onClose={() => dispatch({verified: false})}>Verificatie succesvol.</Alert>
                        )}
                    </>
                }
            </FormStack>
        </div>

    )
}
